import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { Subject } from 'rxjs';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastMessage {
  id: string;
  type: ToastType;
  title?: string;
  message: string;
  timeout?: number;
}

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private _messages = new Subject<ToastMessage>();
  public messages$ = this._messages.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  private emit(type: ToastType, message: string, title?: string, timeout = 4000) {
    if (!isPlatformBrowser(this.platformId)) return;
    const toast: ToastMessage = {
      id: `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
      type,
      title,
      message,
      timeout,
    };
    this._messages.next(toast);
  }

  public success(message: string, title?: string, _?: any) {
    this.emit('success', message, title);
  }

  public danger(message: string, title?: string, _?: any) {
    this.emit('error', message, title);
  }

  public info(message: string, title?: string, _?: any) {
    this.emit('info', message, title);
  }

  public warning(message: string, title?: string, _?: any) {
    this.emit('warning', message, title);
  }

  public exception(e: any, errorMessage: string) {
    console.error(e);
    if (!isPlatformBrowser(this.platformId)) return;

    let msg = errorMessage;
    if (typeof e === 'string') msg = e;
    else if (e.error && typeof e.error === 'string') msg = e.error;

    this.emit('error', msg, 'Exception', 6000);
  }
}
